import { Input } from 'antd';
import colorTheme from 'constants/color';
import React from 'react';
import styled from 'styled-components';
import { REASON_PRESETS } from '../sub-appointment-shared/helpers';

type Props = {
  value: string;
  onChange: (value: string) => void;
  suggestion?: boolean;
  placeholder?: string;
};

const ReasonInput: React.FC<Props> = ({ value, onChange, suggestion = true, placeholder }) => {
  return (
    <Wrapper>
      <Input.TextArea
        className="reason-textarea"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder || 'Type your reason here'}
        autoSize={{ minRows: 3, maxRows: 3 }}
      />
      {!!suggestion && <div className="chips">
        {REASON_PRESETS.map((label) => (
          <button key={label} type="button" className="chip" onClick={() => onChange(label)}>
            {label}
          </button>
        ))}
      </div>}
    </Wrapper>
  );
};

export default ReasonInput;

const Wrapper = styled.div`
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  gap: 8px;

  .reason-textarea {
    height: 80px;
    resize: none;
    border: 1px solid ${colorTheme.v2_border_2};
    border-radius: 4px;
    padding: 7px 13px;
    color: ${colorTheme.v2_text_5};
    font-family: Poppins;
    font-size: 16px;
    &::placeholder {
      color: ${colorTheme.v2_border_2};
    }
  }

  .chips {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .chip {
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 8px;
    border-radius: 4px;
    background: ${colorTheme.v2_secondary_1};
    color: ${colorTheme.v2_text_5};
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    white-space: nowrap;
  }
`;
